// @ts-check
import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SplashScreen from "../../pages/splachscreen/page";
import { getStudyByID } from "../../api/studies";
import Study from "../../models/studies/study";
const Visor = lazy(() => import("../NuevoVisor/Visor"));

function Local() {
  const { id } = useParams();
  const [study, setstudy] = useState(/** @type {Study | null} */ (null));
  useEffect(() => {
    async function init() {
      if (!id) return;
      let estudio = await getStudyByID(parseInt(id));
      setstudy(estudio);
    }
    init();
  }, []);
  return (
    <Suspense fallback={<SplashScreen message="Inicializando Visor" />}>
      {study ? (
        <Visor estudio={study} />
      ) : (
        <SplashScreen message="Cargando Componentes" />
      )}
    </Suspense>
  );
}

export default Local;
